import axios from 'axios';
import { config_headers, servicelist, URL_API } from '../Config';

export const P206FGetDataList= async (body) => {

    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_inspect_case_5_info`), body, authorization) 
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P206FUpdateData= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_inspect_case_5_update`), body, authorization) 
                .then(res => {
                    resolve(res);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}


